// extracted by mini-css-extract-plugin
export default {"button":"books_button__6jtxh","books":"books_books__lSLya","detailbook":"books_detailbook__b9YwQ","btnContainer":"books_btnContainer__9rfWl"};